/** Manual trade's visible-bar window options (`All` shows everything loaded). */
export type QuantManualSpan = '120' | '240' | '600' | 'all'

export const SPAN_BARS: Record<QuantManualSpan, number> = {
  '120': 120,
  '240': 240,
  '600': 600,
  all: Number.MAX_SAFE_INTEGER,
}
